module.exports = __webpack_public_path__ + "static/media/web.5a2c71d4.config";